import React, { useState, useEffect, useRef } from 'react'
import road from '../Assets/racing/road.jpg'
import scenery from '../Assets/racing/scenery.jpg'
import wind from '../Assets/racing/wind.png'
import car1 from '../Assets/racing/car1.png'
import car2 from '../Assets/racing/car2.png'
import car3 from '../Assets/racing/car3.png'
import car4 from '../Assets/racing/car4.png'
import car5 from '../Assets/racing/car5.png'
import car6 from '../Assets/racing/car6.png'
import car7 from '../Assets/racing/car7.png'
import car8 from '../Assets/racing/car8.png'
import car9 from '../Assets/racing/car9.png'
import car10 from '../Assets/racing/car10.png'

const RaceComponent = () => {
    const [windvisible, setWindvisible] = useState(false)
    const [isRacing, setIsRacing] = useState(false)
    let intervalId = null
    intervalId = setInterval(()=>{
        setWindvisible(!windvisible)
    }, 200)

    function startRace(){
        setIsRacing(true)
        setCars(
            (prev) => [...prev], {position: 'right-[50px]'}
        )
    }
    

    const [cars, setCars] = useState([
        {
            car:car1,
            wind:wind,
            position:'top-0',
            wposition:'-top-[2px]',
            positionX:'right-[0px]',
            wpositionX:'right-[3px]'
        },{
            car:car2,
            wind:wind,
            position:'top-[13px]',
            wposition:'top-[11px]',
            positionX:'right-[0px]',
            wpositionX:'right-[3px]'
        },{
            car:car3,
            wind:wind,
            position:'top-[26px]',
            wposition:'top-[23px]',
            positionX:'right-[0px]',
            wpositionX:'right-[3px]'
        },{
            car:car4,
            wind:wind,
            position:'top-[39px]',
            wposition:'top-[36px]',
            positionX:'right-[0px]',
            wpositionX:'right-[3px]'
        },{
            car:car5,
            wind:wind,
            position:'top-[52px]',
            wposition:'top-[49px]',
            positionX:'right-[0px]',
            wpositionX:'right-[3px]'
        },{
            car:car6,
            wind:wind,
            position:'top-[65px]',
            wposition:'top-[62px]',
            positionX:'right-[0px]',
            wpositionX:'right-[3px]'
        },{
            car:car7,
            wind:wind,
            position:'top-[78px]',
            wposition:'top-[75px]',
            positionX:'right-[0px]',
            wpositionX:'right-[3px]'
        },{
            car:car8,
            wind:wind,
            position:'top-[91px]',
            wposition:'top-[88px]',
            positionX:'right-[0px]',
            wpositionX:'right-[3px]'
        },{
            car:car9,
            wind:wind,
            position:'top-[104px]',
            wposition:'top-[101px]',
            positionX:'right-[0px]',
            wpositionX:'right-[3px]'
        },{
            car:car10,
            wind:wind,
            position:'top-[117px]',
            wposition:'top-[114px]',
            positionX:'right-[0px]',
            wpositionX:'right-[3px]'
        },
    ])


    useEffect(()=>{
        console.log(cars)
    }, [cars])
  return (
    <div onClick={startRace} className='select-none relative flex flex-col w-[375px]'>
        <div className=' overflow-x-auto min-w-[375px]'>
            <img className='transition-transform duration-[2000ms] ease-in-out transform-x-[375px] min-w-[750px] h-[35px]' src={scenery} alt=''/>
        </div>
        <img className ='h-[130px]'src={road} alt=''/>
        <div className='absolute bg-purple-600 top-[32px] right-0 w-full flex flex-col'>
            <div className='relative h-full w-full'>
            { cars.map((car,index) =>(
            <img key={index} className={`transition-transform duration-500 ease-in-out absolute w-[50px] ${car.position} ${car.positionX}`} src={car.car} alt=''/> 
            ))}
            { cars.map((car,index) =>(
            windvisible && isRacing && <img key={index} className={`transition-transform duration-500 ease-in-out absolute w-[50px] ${car.wposition} ${car.wpositionX}`} src={car.wind} alt=''/>
               
            ))}
            </div>
        </div>
    </div>
  )
}

export default RaceComponent